module.exports = __webpack_public_path__ + "img/anan.bb9578a8.jpg";